import React, { useState, useRef } from 'react'
import glamorous from 'glamorous'
import to from 'await-to-js'
import { css } from 'glamor'
import { HeadingText, RadioButton } from '@paypalcorp/pp-react'
import getContent from 'pp-react-l10n'
import { SELLER_SETTING_TYPES as types } from 'utils/constants'
import { showServiceError } from './../../error/util'
import SaveButton from '../shared/save-button'

const l10n = getContent('pages/seller/settings')

const Container = glamorous.div({
  display: 'flex',
  flexDirection: 'column',
})

const Heading = css({
  marginTop: 80,
  marginBottom: 40,
  '@media(max-width: 414px)': {
    marginTop: 20,
  },
})

const Legend = glamorous.span({
  border: 0,
  clip: 'rect(1px, 1px, 1px, 1px)',
  height: '1px',
  margin: '-1px',
  overflow: 'hidden',
  padding: 0,
  position: 'absolute',
  width: '1px',
})

function ProfileStatusSetting(props) {
  const {
    sellerProfileState: {
      state: {
        sellerProfileDetails: {
          id: businessHandle = '',
          status = 'INACTIVE',
        } = {},
      } = {},
    } = {},
  } = props
  const profileStatus = status === 'ACTIVE' ? types.SHOW : types.HIDE
  const { turnOnSellerProfile } = props.sellerProfileState
  const [value, setValue] = useState(profileStatus)
  const { current: initialValue } = useRef(value)
  const isChanged = value !== initialValue

  const handleChangeInput = (e) => {
    setValue(e.target.value)
  }

  const handleSave = async () => {
    if (value === types.SHOW) {
      // activate profile
      const [err] = await to(turnOnSellerProfile(businessHandle))
      if (err) {
        showServiceError(err, props.history)
      } else {
        props.history.push(`/seller/${businessHandle}/settings`)
      }
    } else {
      // redirect to confirm before deactivating profile
      props.history.push(`/seller/${businessHandle}/settings/profile/confirm`)
    }
  }

  const options = [
    {
      label: l10n('edit.status.option.on'),
      value: types.SHOW,
      helperText: l10n('edit.status.option.onText'),
    },
    {
      label: l10n('edit.status.option.off'),
      value: types.HIDE,
      helperText: l10n('edit.status.option.offText'),
    },
  ]

  return (
    <Container>
      <HeadingText
        size="md"
        role="heading"
        aria-level="1"
        className={`${Heading}`}
      >
        {l10n('edit.status.header')}
      </HeadingText>
      <RadioButton
        name="profileStatus"
        label={<Legend>{l10n('edit.status.header')}</Legend>}
        value={value}
        options={options}
        onChange={handleChangeInput}
      />
      {isChanged && <SaveButton handleSave={handleSave} />}
    </Container>
  )
}

export default ProfileStatusSetting
